import './scss/style.scss';

import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './services/Permission/PrivateRoute'
import AcessoNegado from './pages/AcessoNegado';
import NotFound from './pages/NotFound';
import CompleteMfaCallback from './pages/Mfa';
import { Loading } from './components';
import { CaptchaContextProvider } from './contexts/CaptchaContext';

// Containers
const Login = React.lazy(() => import('./pages/Login'));
const Default = React.lazy(() => import('./containers/Default'));
const Public = React.lazy(() => import('./containers/Default/Public'));

class App extends Component {
  render() {
    return (
      <CaptchaContextProvider>
        <React.Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/login" id="Login Page" element={<Login />} />
            <Route path="/404" id="Page 404" element={<NotFound />} />
            <Route path="/500" id="Page 500" element={<AcessoNegado />} />
            <Route path="/publico/*" id="Acesso Publico" element={<Public />} />
            <Route path="/auth-callback" element={<CompleteMfaCallback />} />
            <Route path="*" id="Home"
              element={
                <PrivateRoute name="Home">
                  <Default />
                </PrivateRoute>
              }
            />
          </Routes>
        </React.Suspense>
      </CaptchaContextProvider>
    );
  };
}

export default App;